<section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-6">
        <div class="d-flex justify-content-center py-4">
          <a href="index.html" class="logo d-flex align-items-center w-auto">
            <img src="assets/img/logo.png" alt="" />
            <span class="d-none d-lg-block">Patient Tracker</span>
          </a>
        </div>
        <!-- End Logo -->
        <ng-container *ngIf="!IsEmailSubmiteed">
          <div class="card mb-3">
            <div class="card-body">
              <div class="pb-2">
                <h5 class="card-title pb-0 fs-4 mb-2">Forget password ?</h5>
                <p class="small">Enter your email here</p>
              </div>

              <form class="row g-3">
                <div class="col-12 mb-3">
                  <label for="email" class="form-label">Email</label>
                  <div class="input-group has-validation">
                    <input type="email" name="email" class="form-control" id="email" required [(ngModel)]="Email" #email="ngModel" />
                    <div class="invalid-feedback d-block" *ngIf="email.invalid && email.touched">Please enter your username.</div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="d-flex">
                    <button tabindex="-1" class="btn btn-light me-3" routerLink="../signin">
                      <span class="bi bi-arrow-left"></span>
                    </button>
                    <button class="btn btn-primary w-100" (click)="SubmitEmail()" [disabled]="email.invalid" type="button">Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="IsEmailSubmiteed">
          <div class="card mb-3">
            <div class="card-body">
              <div class="pb-2">
                <h5 class="card-title pb-0 fs-4 mb-2">Enter OTP</h5>
                <p class="small">Didn't get an OTP ? <a href="#">Resend</a></p>
              </div>

              <form class="row g-3">
                <div class="col-12 mb-3">
                  <label for="otp" class="form-label">OTP</label>
                  <div class="input-group has-validation">
                    <input
                      [(ngModel)]="OTP"
                      #otp="ngModel"
                      type="text"
                      name="username"
                      class="form-control"
                      id="otp"
                      required
                      [maxlength]="OTPMaxLength"
                      (keydown)="sharedService.validateNumber($event)"
                    />
                    <div class="invalid-feedback d-block" *ngIf="otp.invalid && otp.touched">Please enter OTP.</div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="d-flex">
                    <button class="btn btn-primary w-100" (click)="SubmitOTP()" [disabled]="otp.invalid" type="button">Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
